import ReportsOfSicknessImportNew from '@/views/constants/reports-of-sickness-import-new';

const Steps = {
  create () {
    return [{
      number: 1,
      title: 'Upload Import Bestand',
      text: 'Middels de wizard dient u een bestand in wat de te verwerken verzuimmeldingen bevat.',
      completed: false,
      active: true,
      view: ReportsOfSicknessImportNew.Views.ImportFile,
      navigateAction: ReportsOfSicknessImportNew.Actions.NAVIGATE
    },
    {
      number: 2,
      title: 'Bevestiging Import',
      text: 'Controleer alle gegevens en geef bevestiging om de import daadwerkelijk in te dienen.',
      completed: false,
      active: false,
      view: ReportsOfSicknessImportNew.Views.ImportReport,
      navigateAction: ReportsOfSicknessImportNew.Actions.NAVIGATE
    }];
  }
};

const state = {
  reportsOfSicknessImportNewSteps: Steps.create()
};

const getters = {
  reportsOfSicknessImportNewSteps: state => state.reportsOfSicknessImportNewSteps,
  reportsOfSicknessImportNewActiveView: state => state.reportsOfSicknessImportNewSteps.find(s => s.active).view
};

const actions = {
  [ReportsOfSicknessImportNew.Actions.NAVIGATE] ({ commit, rootGetters }, view) {
    if (view === ReportsOfSicknessImportNew.Views.ImportReport) {
      if (rootGetters.reportsOfSicknessNewImportFile == null) return;
    }
    commit(ReportsOfSicknessImportNew.Mutations.SET_ACTIVE_VIEW, view);
  },

  [ReportsOfSicknessImportNew.Actions.SELECT_FILE] ({ commit }, file) {
    if (file != null) {
      // for now we can just call update completed.
      // there is a file, and its the only thing needed for completion.
      commit(ReportsOfSicknessImportNew.Mutations.SET_COMPLETED,
        ReportsOfSicknessImportNew.Views.ImportFile);
    }
  },

  [ReportsOfSicknessImportNew.Actions.CANCEL] ({ commit }) {
    commit(ReportsOfSicknessImportNew.Mutations.CLEAR);
  }
};

const mutations = {
  [ReportsOfSicknessImportNew.Mutations.CLEAR] (state, payload) {
    state.reportsOfSicknessImportNewSteps = Steps.create();
  },

  [ReportsOfSicknessImportNew.Mutations.SET_COMPLETED] (state, payload) {
    state.reportsOfSicknessImportNewSteps.forEach(s => {
      switch (s.view) {
        case ReportsOfSicknessImportNew.Views.ImportFile:
          s.completed = payload === ReportsOfSicknessImportNew.Views.ImportFile;
          break;
      }
    });
  },

  [ReportsOfSicknessImportNew.Mutations.SET_ACTIVE_VIEW] (state, payload) {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    state.reportsOfSicknessImportNewSteps.forEach(s => {
      s.active = (s.view === payload);
    });
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
